module.exports = __webpack_public_path__ + "static/img/Jack-Howarth.314d139.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jack-Howarth.jpg
// module id = /nkY
// module chunks = 0